export default __webpack_public_path__ + "static/media/group.ad2b2546.svg";